module.exports = __webpack_public_path__ + "static/media/shape_summer-secound.e5c02f2e.svg";